import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function Forbidden() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:px-8 text-center space-y-8 pb-32">
      <Helmet>
        <title>403 - Ingen adgang - CRE8IT</title>
        <meta name="description" content="Fejl 403: Du har ikke adgang til denne side." />
      </Helmet>

      <div className="space-y-4">
        <div className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-brand-green-light/30 text-brand-red">
          <i className="fa-solid fa-lock text-2xl" />
        </div>
        <h1 className="text-4xl font-extrabold text-gray-900 sm:text-5xl">403 - Ingen adgang</h1>
        <p className="text-lg text-gray-500 max-w-md mx-auto">
          Du har ikke tilladelse til at tilgå denne ressource eller side.
        </p>
      </div>

      <div className="flex justify-center gap-4">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 rounded-xl bg-gray-900 px-6 py-3 text-sm font-semibold text-white shadow-sm transition-all hover:bg-gray-800"
        >
          <i className="fa-solid fa-house" />
          Gå til forsiden
        </Link>
        <Link
          to="/kontakt"
          className="inline-flex items-center justify-center gap-2 rounded-xl border border-gray-300 bg-white px-6 py-3 text-sm font-semibold text-gray-700 shadow-sm transition-all hover:bg-gray-50"
        >
          <i className="fa-solid fa-envelope" />
          Kontakt os
        </Link>
      </div>
    </div>
  );
}
